var brandAssets = [
    {
        alt: 'Chuffed.org logo, blue 350px',
        backgroundColor: null,
        filename: 'chuffedorg-logo-blue-350px.png',
    },
    {
        alt: 'Chuffed.org logo, black 350px',
        backgroundColor: null,
        filename: 'chuffedorg-logo-black-350px.png',
    },
    {
        alt: 'Chuffed.org logo, white 350px',
        backgroundColor: '#1fa8df',
        filename: 'chuffedorg-logo-white-350px.png',
    },
    {
        alt: 'Chuffed.org logo, blue 150px',
        backgroundColor: null,
        filename: 'chuffed-org-logo-blue-150px.png',
    },
    {
        alt: 'Chuffed.org logo, black 150px',
        backgroundColor: null,
        filename: 'chuffedorg-logo-black-150px.png',
    },
    {
        alt: 'Chuffed.org logo, white 150px',
        backgroundColor: '#1fa8df',
        filename: 'chuffedorg-logo-white-150px.png',
    },
];
export default brandAssets;
